import classNames from "classnames"
import React from "react"
import classes from "./CustomCalendarButton.module.css"

interface Props {
  disabled?: boolean
  withBackground?: boolean
  selected?: boolean
  onClick?: () => void
  children: any
  className?: string
}

const CustomCalendarButton = ({
  children,
  disabled,
  selected,
  onClick,
  withBackground,
  className,
}: Props) => {
  return (
    <div
      className={classNames(
        classes.root,
        {
          [classes.enabled]: disabled !== true,
          [classes.withBackground]: disabled !== true && withBackground,
          [classes.selected]: disabled !== true && selected,
        },
        className
      )}
      onClick={() => disabled !== true && onClick?.()}
    >
      {children}
    </div>
  )
}

export default CustomCalendarButton
